import { useEffect, useState } from "react";
import type * as React from "react";

import { useDispatch } from "react-redux";

import { Dropdown } from "@similarweb/ui-components";

import { toggleUserSettings } from "app/actions/userData/primarySidebar3Actions";
import { getPlainTooltip, loader } from "app/components/sidebar3/primary-side-bar/secondary-actions/Solutions/utils";
import { SolutionsSwitcherMenuComponent } from "app/components/sidebar3/primary-side-bar/secondary-actions/Solutions/SolutionsSwitcherMenuComponent";
import { SolutionSwitcherDropdownWrapper } from "app/components/sidebar3/primary-side-bar/styledComponents";
import { swSettings } from "app/common/services/swSettings";
import type { ISubscriptionSolution } from "app/user-data/solutionBaseInterfaces";

interface ISolutionSwitcherDropdown {
    isCollapsed: boolean;
    onTrack?: () => void;
}

export const SolutionSwitcherDropdown: React.FC<ISolutionSwitcherDropdown> = ({ isCollapsed, onTrack }) => {
    const [subscriptionSolutions, setSubscriptionSolutions] = useState<ISubscriptionSolution[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(toggleUserSettings(false));
    }, [dispatch]);

    useEffect(() => {
        setIsLoading(true);
        setSubscriptionSolutions(swSettings.subscriptionSolutions);
        setIsLoading(false);
    });

    const onDropdownToggle = (isOpen: boolean): void => {
        if (isOpen) {
            onTrack?.();
        }
        dispatch(toggleUserSettings(isOpen));
    };

    return (
        <SolutionSwitcherDropdownWrapper isCollapsed={isCollapsed}>
            <Dropdown
                width={220}
                dropdownPopupHeight={496}
                buttonWidth={"auto"}
                appendTo={"body"}
                dropdownPopupPlacement="right"
                closeOnItemClick={false}
                cssClassContainer={"DropdownContent-container UserSettingsDropDownContent-container-sidebar3 right-top"}
                onToggle={onDropdownToggle}
            >
                {isLoading
                    ? [getPlainTooltip(), loader]
                    : [
                          getPlainTooltip(),
                          <SolutionsSwitcherMenuComponent
                              subscriptionSolution={subscriptionSolutions}
                              key="SolutionSwitcherMenuComponentNewSidebar"
                          />,
                      ]}
            </Dropdown>
        </SolutionSwitcherDropdownWrapper>
    );
};
